const BookingsComponent = () => import("@/views/bookings/index.vue");
const ViewBookingsComponent = () => import("@/views/bookings/view.vue");

export default {
    path: "bookings",
    meta: { label: "Bookings" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            meta: {
                requiresAuth: true,
            },
            component: BookingsComponent,
        },
        {
            path: "view/:id",
            meta: {
                requiresAuth: true,
            },
            component: ViewBookingsComponent,
        },
    ],
};
